import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { toast } from "react-toastify"; // Import toast from react-toastify
import "react-toastify/dist/ReactToastify.css";

const apiBase = process.env.REACT_APP_API;

const Cart = ({ setCartItemCount, setIsLoading }) => {
  const [cartItem, setCartItem] = useState(null);
  const navigate = useNavigate();
  // Fetch cart item details from API and set to state
  useEffect(() => {
    const fetchCartItem = async () => {
      // Get cart item from local storage
      const storedItem = JSON.parse(localStorage.getItem("cartItems"));
      if (!storedItem) return;

      try {
        // Fetch item details from API
        setIsLoading(true);
        const token = localStorage.getItem("token");
        if(!token) {
          navigate("/login");
          toast.error("Please Login first!")
        }
        const response = await fetch(`${apiBase}/payments/cart?quota_id=${storedItem.quota_id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
             Authorization: `Bearer ${token}`
          },
        });
        const itemDetails = await response.json();

        // Set combined data in state
        setCartItem({ ...storedItem, ...itemDetails });
      } catch (error) {
        console.error("Error fetching cart item details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCartItem();
  }, []);

  // Handle remove item
  const handleRemove = () => {
    localStorage.removeItem("cartItems"); // Clear local storage
    setCartItem(null); // Clear state to update UI
    setCartItemCount(0);
  };

  const showName = (name) => {
    switch (name.toLowerCase()) {
      case "jan":
        return "January";
      case "feb":
        return "February";
      case "mar":
        return "March";
      case "apr":
        return "April";
      case "may":
        return "May";
      case "jun":
        return "June";
      case "jul":
        return "July";
      case "aug":
        return "August";
      case "sep":
        return "September";
      case "oct":
        return "October";
      case "nov":
        return "November";
      case "dec":
        return "December";
      default:
        return name;
    }
  };

  console.log(cartItem);

  return (
    <div className="w-full h-full  flex-col mt- justify-center items-center ">
      <div
        className="w-full pattern-dots pattern-white pattern-bg-myBlue 
  pattern-size-2 pattern-opacity-50 py-16 mb-4"
      ></div>
      <div className="flex justify-center items-center w-full">
        <div className="px-4 py-16 w-full md:w-[1024px]">
          <Link to={"/courses"}>
            <h1 className="flex flex-row items-center mb-16">
              <MdKeyboardArrowLeft className="text-4xl opacity-50" />
              <div className="text-2xl opacity-50 font-medium uppercase hover:underline">
                Back to Cources
              </div>
            </h1>
          </Link>
          <div className="  grid grid-cols-1 md:grid-cols-3">
            <div className="md:col-span-2">
              {cartItem ? (
                <div className="cart-item w-full text-base">
                  <div className="flex flex-col md:flex-row justify-between border rounded-lg hover:shadow-sm my-8 md:my-0 md:mx-4 p-5">
                    <div>
                      {/* <h3>Cart: {cartItem.course_name}</h3> */}

                      <h3 className="text-2xl font-semibold ">
                        {cartItem.cTitle}
                      </h3>
                      <h4 className="text-base font-semibold opacity-40 uppercase">
                        {cartItem.quotaMethod} ||{" "}
                        {cartItem.title && showName(cartItem.title)}
                      </h4>
                    </div>
                    <div className="flex flex-col items-end">
                      <p className="text-sm text-myBlue font-semibold">
                        {" "}
                        {cartItem.year}{" "}
                      </p>
                      {/* <p>Year: {cartItem.year}</p> */}
                      <p className="text-4xl font-semibold opacity-75 truncate">
                        LKR {cartItem.price}.00
                      </p>
                      <button
                        onClick={handleRemove}
                        className="text-center border py-1 w-full rounded-lg mt-8 bg-myRed text-white font-semibold hover:bg-opacity-85"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <p>Your cart is empty.</p>
              )}
            </div>
            {/* <div>
      <h2>total price :{cartItem ? ( cartItem.price) : (0) } </h2>
      </div> */}

            <div className="md:col-span-1 flex flex-col justify-between py-4 items-center border rounded-lg">
              <h3 className="text-2xl font-semibold text-center">Payment</h3>
              <div className="w-full px-4 mt-16">
                <Link to={"/checkout/bank"} className="w-full">
                  <button className="my-2 border w-full py-2 rounded-lg text-base font-semibold bg-myRed text-white hover:bg-opacity-85">
                    Bank payment
                  </button>
                </Link>

                <Link to={"/checkout/online"}>
                  <button className="hidden border w-full py-2 rounded-lg text-base font-semibold bg-myPurple text-white hover:bg-opacity-85">
                    online payment
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center my-4">
        <p className="text-lg font-medium text-gray-700">
          <Link
            to={"/support/bankdetails"}
            className="text-myBlue font-semibold underline hover:text-myPurple transition-colors duration-300"
          >
            Click here
          </Link>{" "}
          to see bank details
        </p>
      </div>
      
    </div>
  );
};

export default Cart;
